import React from "react";
import { Window } from "@progress/kendo-react-dialogs";
import "./SidePanel.scss";

function SidePanelGeneric(props) {
  const { visible, onClose, title, children } = props;
  return (
    <Window
      title={title}
      onClose={onClose}
      visible={visible}
      className="position-fixed roboto-15-400"
      initialHeight={window.innerHeight}
      initialWidth={450}
      initialLeft={window.innerWidth - 450}
      style={{ borderRadius: "12px" }}
    >
      <div className="roboto-15-400">{children}</div>
      
    </Window>
  );
}

export { SidePanelGeneric };
